// extracted by mini-css-extract-plugin
export default {"wrapper":"LeftBox_wrapper__WWRBO","top":"LeftBox_top__r5zQl","center":"LeftBox_center__vbkrf","bottom":"LeftBox_bottom__J57qR"};